import { render } from "./badge-seamless.vue?vue&type=template&id=013020dd"
import script from "./badge-seamless.vue?vue&type=script&lang=js"
export * from "./badge-seamless.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__